import {HomeMatchSurveyDto} from "../types/home_match_preferences";

/**
 * The survey always exists - from the moment the account is created,
 * the only option is to check the completion of fields.
 */
export const isHomeMatchSurveyDataEmpty = (data: HomeMatchSurveyDto): boolean => {
    return (!data.regions || data.regions.length === 0) && data.price === null && data.rooms === null;
};
import {HomeMatchSurveyDto} from "../types/home_match_preferences";

/**
 * The survey always exists - from the moment the account is created,
 * the only option is to check the completion of fields.
 */
export const isHomeMatchSurveyDataEmpty = (data: HomeMatchSurveyDto): boolean => {
    return (!data.regions || data.regions.length === 0) && data.price === null && data.rooms === null;
};
